/**
 * Judge.me dark-theme fix: re-apply after JDGM injects late <style> tags and inline colors.
 */
(function () {
  var STAR_ON = '#fbbf24';
  var STAR_OFF = 'rgba(251, 191, 36, 0.38)';
  var TEXT = '#f4f4f5';
  var AUTHOR = '#ffffff';
  var MUTED = '#a1a1aa';
  var ACCENT = '#d4ff4d';
  var DYNAMIC_STYLE_ID = 'ug-jdgm-dynamic-overrides';

  var DYNAMIC_CSS =
    'html body.template-product #judgeme_product_reviews,' +
    'html body.template-product-bundle #judgeme_product_reviews{color:#f4f4f5!important;-webkit-text-fill-color:#f4f4f5!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev-widg *:not(.jdgm-star),' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev-widg *:not(.jdgm-star){color:#f4f4f5!important;-webkit-text-fill-color:#f4f4f5!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__author,' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__author a,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__author,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__author a{color:#fff!important;-webkit-text-fill-color:#fff!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__timestamp,' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__header .jdgm-rev__timestamp,' +
    'html body.template-product #judgeme_product_reviews .jdgm-row-profile .jdgm-rev__timestamp,' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__meta,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__timestamp,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__header .jdgm-rev__timestamp,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-row-profile .jdgm-rev__timestamp,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__meta{color:#a1a1aa!important;-webkit-text-fill-color:#a1a1aa!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-verified-badge,' +
    'html body.template-product #judgeme_product_reviews .jdgm-rev__buyer-badge,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-verified-badge,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-rev__buyer-badge{color:#d4ff4d!important;-webkit-text-fill-color:#d4ff4d!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-star:not(.jdgm--off),' +
    'html body.template-product #judgeme_product_reviews .jdgm-star:not(.jdgm--off)::before,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-star:not(.jdgm--off),' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-star:not(.jdgm--off)::before{color:#fbbf24!important;-webkit-text-fill-color:#fbbf24!important}' +
    'html body.template-product #judgeme_product_reviews .jdgm-star.jdgm--off,' +
    'html body.template-product #judgeme_product_reviews .jdgm-star.jdgm--off::before,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-star.jdgm--off,' +
    'html body.template-product-bundle #judgeme_product_reviews .jdgm-star.jdgm--off::before{color:rgba(251,191,36,.38)!important;-webkit-text-fill-color:rgba(251,191,36,.38)!important}' +
    'html body.template-product .ug-bundle-reviews .ug-bundle-section__title,' +
    'html body.template-product-bundle .ug-bundle-reviews .ug-bundle-section__title{color:#f4f4f5!important;-webkit-text-fill-color:#f4f4f5!important}';

  function setColor(el, color) {
    if (!el || el.classList.contains('jdgm-star')) return;
    el.style.setProperty('color', color, 'important');
    el.style.setProperty('-webkit-text-fill-color', color, 'important');
  }

  function isStarEl(el) {
    return el.classList && (el.classList.contains('jdgm-star') || (el.closest && el.closest('.jdgm-star')));
  }

  function isIconChromeEl(el) {
    if (!el.classList) return false;
    if (el.classList.contains('jdgm-star')) return true;
    if (el.matches(
      '.jdgm-custom-forms-filters__button, .jdgm-review-search-wrapper, .jdgm-favicon, .jdgm-favicon *'
    )) return true;
    var cls = el.className;
    if (typeof cls === 'string' && (cls.indexOf('jm-ico') !== -1 || cls.indexOf('jdgm-ico') !== -1)) return true;
    return false;
  }

  // The revamp widget's compact sort control is an icon-only button backed by a
  // native <select>. Its selected-option text ("Most recent") is meant to stay
  // hidden — only the sort SVG (in a sibling span) shows. Forcing a visible text
  // colour on it made the clipped first letter render as a stray "M" over the icon.
  function isSortSelect(el) {
    return el.matches && el.matches('.jm-sort-filter__select, select.jdgm-sort-dropdown');
  }

  function setWidgetVars(root) {
    root.style.setProperty('color', TEXT, 'important');
    root.style.setProperty('-webkit-text-fill-color', TEXT, 'important');
    root.style.setProperty('--jdgm-reviewer-name-color', AUTHOR, 'important');
    root.style.setProperty('--jdgm-text-color', TEXT, 'important');
    root.style.setProperty('--jdgm-review-text-color', TEXT, 'important');
    root.style.setProperty('--jdgm-heading-color', AUTHOR, 'important');
    root.style.setProperty('--jdgm-star-color', STAR_ON, 'important');
    root.style.setProperty('--jdgm-primary-color', ACCENT, 'important');
    root.style.setProperty('--jdgm-paginate-color', TEXT, 'important');
  }

  function paintStars(root) {
    root.querySelectorAll('.jdgm-star').forEach(function (star) {
      var c = star.classList.contains('jdgm--off') ? STAR_OFF : STAR_ON;
      star.style.setProperty('color', c, 'important');
      star.style.setProperty('-webkit-text-fill-color', c, 'important');
    });
  }

  function paintAllText(root) {
    setWidgetVars(root);

    root.querySelectorAll('*').forEach(function (el) {
      if (!el.classList) return;
      if (isStarEl(el)) return;
      if (isIconChromeEl(el)) return;
      if (isSortSelect(el)) {
        el.style.setProperty('color', 'transparent', 'important');
        el.style.setProperty('-webkit-text-fill-color', 'transparent', 'important');
        return;
      }
      if (/^(STYLE|SCRIPT|SVG|PATH|IMG|PICTURE|SOURCE|VIDEO)$/.test(el.tagName)) return;

      var color = TEXT;
      if (el.matches('.jdgm-rev__author, .jdgm-rev__author *, .jdgm-row-profile .jdgm-rev__author, .jdgm-row-profile .jdgm-rev__author *')) {
        color = AUTHOR;
      } else if (el.matches(
        '.jdgm-rev__timestamp, .jdgm-rev__header .jdgm-rev__timestamp, .jdgm-row-profile .jdgm-rev__timestamp, .jdgm-rev__meta, .jdgm-rev__meta *'
      )) {
        color = MUTED;
      } else if (el.matches('.jdgm-verified-badge, .jdgm-rev__buyer-badge')) {
        color = ACCENT;
      } else if (el.matches('.jdgm-link, .jdgm-histogram__clear-filter, .jdgm-btn--link')) {
        color = ACCENT;
      } else if (el.matches('.jdgm-write-rev-link, .jdgm-custom-forms-filters__button, .jdgm-ask-question-btn')) {
        color = AUTHOR;
      }
      setColor(el, color);
    });
  }

  function paintSectionTitles() {
    document.querySelectorAll('.ug-bundle-reviews .ug-bundle-section__title').forEach(function (el) {
      setColor(el, TEXT);
    });
  }

  function injectDynamicStyle() {
    var el = document.getElementById(DYNAMIC_STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = DYNAMIC_STYLE_ID;
      el.setAttribute('data-ug-jdgm-overrides', 'dynamic');
    }
    el.textContent = DYNAMIC_CSS;
    document.body.appendChild(el);
  }

  function injectStylesheet() {
    var url = window.UG_JDGM_OVERRIDES_URL;
    if (url) {
      var link = document.querySelector('link[data-ug-jdgm-overrides]');
      if (!link) {
        link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.setAttribute('data-ug-jdgm-overrides', '');
      }
      document.body.appendChild(link);
    }

    var inline = document.getElementById('ug-jdgm-text-fix');
    if (inline) document.body.appendChild(inline);

    injectDynamicStyle();
  }

  function ensureThemeStyles() {
    injectStylesheet();
    var root = document.getElementById('judgeme_product_reviews');
    if (root) {
      paintStars(root);
      paintAllText(root);
    }
    paintSectionTitles();
  }

  window.ugEnsureJdgmThemeStyles = ensureThemeStyles;

  function patchRenderWidgets() {
    if (!window.jdgm || window.jdgm.__ugThemePatched) return;
    window.jdgm.__ugThemePatched = true;
    var original = window.jdgm.renderWidgets;
    if (typeof original !== 'function') return;
    window.jdgm.renderWidgets = function () {
      var result = original.apply(this, arguments);
      ensureThemeStyles();
      setTimeout(ensureThemeStyles, 50);
      setTimeout(ensureThemeStyles, 300);
      setTimeout(ensureThemeStyles, 1000);
      setTimeout(ensureThemeStyles, 2500);
      setTimeout(ensureThemeStyles, 5000);
      return result;
    };
  }

  function watchWidget() {
    var root = document.getElementById('judgeme_product_reviews');
    if (!root) return;
    var timer;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(ensureThemeStyles, 80);
    });
    obs.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    setTimeout(function () {
      obs.disconnect();
    }, 60000);
  }

  function watchJdgmStyleInjection() {
    var timer;
    var obs = new MutationObserver(function (mutations) {
      var touched = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (node) {
          return node.nodeType === 1 && (
            node.matches && (node.matches('style.jdgm-stylesheet, style.jdgm-settings-style, link.jdgm-stylesheet') ||
              (node.querySelector && node.querySelector('style.jdgm-stylesheet, style.jdgm-settings-style, link.jdgm-stylesheet')))
          );
        });
      });
      if (!touched) return;
      clearTimeout(timer);
      timer = setTimeout(ensureThemeStyles, 50);
    });
    obs.observe(document.body, { childList: true });
    setTimeout(function () {
      obs.disconnect();
    }, 60000);
  }

  function init() {
    patchRenderWidgets();
    ensureThemeStyles();
    watchWidget();
    watchJdgmStyleInjection();
    setTimeout(ensureThemeStyles, 100);
    setTimeout(ensureThemeStyles, 500);
    setTimeout(ensureThemeStyles, 2000);
    setTimeout(ensureThemeStyles, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('page:load', init);
  document.addEventListener('turbolinks:load', init);
  document.addEventListener('turbo:load', init);
})();
